import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class IntelligentDataHead extends Component {
  render() {
    return (
      <table className="intelligentDataHead_table_box">
        <tbody>
          <tr>
            <td
              style={{
                borderLeft: 0,
                width: "42%",
                textAlign: "left",
                paddingLeft: "5px",
              }}
            >
              院校代码、院校（专业）名
            </td>
            <td style={{ width: "10%" }}>计划人数</td>
            <td style={{ width: "5%" }}>学制</td>
            <td style={{ width: "10%" }}>培养层次</td>
            <td style={{ width: "10%" }}>最低分</td>
            <td style={{ borderRight: 0, width: "23%" }}>位次号</td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default IntelligentDataHead;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentDataHead/index.js